import Vue from 'vue';
import Vuex from 'vuex';
import indexx from './indexx';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        indexx
    }
});
